const trackEvent = (action, category, label) => {
    if (typeof gtag === 'function') {
        return gtag('event', action, {
            'event_category': category,
            'event_label': label
        });
    }

    if (typeof ga === 'function') {
        return ga('send', {
            hitType: 'event',
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            transport: 'beacon'
        });
    }
}

export {trackEvent}
